export default __webpack_public_path__ + "static/media/00.b109a2da.jpg";